import { render, staticRenderFns } from "./ActivityForms.vue?vue&type=template&id=20098a2a&scoped=true&"
import script from "./ActivityForms.vue?vue&type=script&lang=js&"
export * from "./ActivityForms.vue?vue&type=script&lang=js&"
import style0 from "./ActivityForms.vue?vue&type=style&index=0&id=20098a2a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20098a2a",
  null
  
)

export default component.exports